"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessage = void 0;
exports.ErrorMessage = {
    INVALID_AUTH: "invalid_auth",
    AUTH_SERVER_UNAVAILABLE: "auth_server_unavailable",
};
